import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    uid: z.string(),
  }),
  response: z.void(),
};
